export const Title  = ({newTitle}) => {
    document.title=newTitle;
    return document.title;  
}

